import 'moment/locale/it';
import * as logicUser from "@logic/user";
import AppFooter from "./AppFooter";
import AppNavBar from "./AppNavBar";
import AppRouting from "./AppRouting";
import AppTopBar from "./AppTopBar";
import Dialogs from "@templates/dialogs";
import Modals from "@templates/modals";
import React, { useEffect, useMemo } from "react";
import Snackbars from "@templates/snackbars";
import moment from "moment";
import styles from "./App.module.css";
import { CategoriesProvider } from "@contexts/CategoriesContext";
import { DialogsProvider } from "@contexts/DialogsContext";
import { ModalsProvider } from "@contexts/ModalsContext";
import { NavigatorProvider, ROUTES, useNavigator } from "@contexts/NavigatorContext";
import { SnackbarsProvider } from "@contexts/SnackbarsContext";
import { useDispatch } from "react-redux";

const AppLayout = () => {
  const { currentRoute } = useNavigator();

  const pageClassName = useMemo(() => ([
    styles.page,
    currentRoute?.url === ROUTES.ADMIN_VALIDAZIONE.url ? styles.pageFullWidth : null,
  ].filter(Boolean).join(" ")),
  [currentRoute?.url]);

  return (
    <div className={pageClassName}>
      <AppNavBar />
      <AppTopBar />
      <div className={styles.body}>
        <AppRouting />
      </div>
      <AppFooter />
    </div>
  );
};

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    moment.locale('it');
    dispatch(logicUser.restoreSignIn());
  }, [dispatch]);

  return (
    <ModalsProvider>
      <CategoriesProvider>
        <NavigatorProvider>
          <SnackbarsProvider>
            <DialogsProvider>
              <AppLayout />
              <Modals />
              <Dialogs />
              <Snackbars />
            </DialogsProvider>
          </SnackbarsProvider>
        </NavigatorProvider>
      </CategoriesProvider>
    </ModalsProvider>
  );
};

export default App;
